<p-drawer
  [(visible)]="isActive"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  styleClass="filters-sidebar"
  [style]="{ width: '400px' }"
  (onHide)="onSidebarHide()">
  <ng-template pTemplate="header">
    <div class="sidebar-header">
      <div class="header-left">
        <i class="pi pi-filter"></i>
        <span class="font-bold">{{ tk.General.Filters | t }}</span>
      </div>
    </div>
  </ng-template>

  <div class="filter-content">
    <form [formGroup]="filterForm" appAutoFormGroup>
      <!-- Período de Vencimento -->
      <div class="mt-4">
        <label class="field-group-label">Período de Vencimento</label>
        <div class="field-group">
          <div class="field-half">
            <app-calendar label="De" placeholder="Data inicial" [controlName]="'dateFrom'" />
          </div>
          <div class="field-half">
            <app-calendar label="Até" placeholder="Data final" [controlName]="'dateTo'" />
          </div>
        </div>
      </div>

      <!-- Tipo de Operação -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [controlName]="'operationType'"
          [label]="'Tipo de Operação'"
          [placeholder]="'Selecione o tipo'"
          [options]="operationOptions" />
      </div>

      <!-- Moeda -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [controlName]="'internationalCurrencyId'"
          [label]="'Moeda'"
          [placeholder]="'Selecione a moeda'"
          [options]="(currencies$ | async) || []" />
      </div>

      <!-- Empresa -->
      <div class="mt-4">
        <app-select-company
          [allowEmptyPlaceholderSelect]="true"
          [controlName]="'companyId'"
          [label]="'Empresa'"
          [placeholder]="'Selecione a empresa'" />
      </div>

      <!-- Faixa de Valor -->
      <div class="mt-4">
        <label class="field-group-label">Faixa de Valor</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              type="number"
              [totalFractionDigits]="2"
              prefix="R$ "
              label="Valor mínimo"
              placeholder="0,00"
              [controlName]="'notionalAmountFrom'" />
          </div>
          <div class="field-half">
            <app-input
              type="number"
              [totalFractionDigits]="2"
              prefix="R$ "
              label="Valor máximo"
              placeholder="0,00"
              [controlName]="'notionalAmountTo'" />
          </div>
        </div>
      </div>

      <!-- Referência -->
      <div class="mt-4">
        <app-input
          [controlName]="'reference'"
          [label]="'Referência'"
          [placeholder]="'Digite a referência'" />
      </div>

      <!-- Operações Contratadas -->
      <div class="mt-4">
        <p-checkbox
          [formControlName]="'withHiredOperations'"
          binary="true"
          label="Operações Contratadas"
          inputId="withHiredOperations" />
      </div>

      <!-- Operações Ativas e Abertas -->
      <div class="mt-4">
        <p-checkbox
          [formControlName]="'withHiredOperationsOpen'"
          binary="true"
          label="Operações Ativas e Abertas"
          inputId="withHiredOperationsOpen" />
      </div>
    </form>
  </div>

  <div class="filter-actions">
    <div class="d-flex justify-content-between align-items-center p-3">
      <app-button
        [label]="tk.General.Clear | t"
        type="button"
        (sendButtonClick)="clear()"
        theme="white" />
      <app-button [label]="tk.General.Filter | t" type="button" (sendButtonClick)="submit()" />
    </div>
  </div>
</p-drawer>
